import { StepType } from 'src/app/shared/shared.module';
import { CommonExitInputs } from './common-exit-type-inputs';
import { CommonService } from 'src/app/core/common.service';
import { ExitApi } from 'src/app/core/api.gen';

export class ExitType extends CommonExitInputs {

    constructor(
        common: CommonService,
        exitApi: ExitApi) {
        super(common);
    }

    ExitCommonInputs(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            //this.nationality(),

                        ]
                    },
                ]
            }];
    }
}
